export default {
  CALL_BACK_REQUEST: 1,
  CHECK_TASK: 2,
  CORRESPOND_TASK: 3,
  BIRTHDAY_TASK: 4,
  GENERAL_TASK: 20,
  MAINTENANCE_PRIVATE: 30,
  MAINTENANCE_BUSINESS: 31,
};
